import React from 'react';
import { ReadOnlyCustomsWidgetHeader } from './sections/header/readonly-header';
import { CustomsDeclarationsSection } from './sections/declarations';

export const ReadOnlyCustomsWidget = () => (
  <>
    <ReadOnlyCustomsWidgetHeader />
    <CustomsDeclarationsSection readOnly />
  </>
);
